import { render } from "./OrderView.vue?vue&type=template&id=2153aa2b&ts=true"
import script from "./OrderView.vue?vue&type=script&lang=ts"
export * from "./OrderView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__